<template>
    <v-row justify="center">
        <v-dialog v-model="dialogConfirm" persistent max-width="300">
            <v-card>
                <v-card-title class="text-h5">
                    {{ titulo }}
                </v-card-title>
                <v-card-text>{{ mensaje }}.</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="cerrar">
                        Cancelar
                    </v-btn>
                    <v-btn color="red darken-1" text @click="continueEm">
                        Continuar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: false
        },
        titulo: {
            type: String,
            default: ""
        },
        mensaje: {
            type: String,
            default: ""
        },
    },

    data: () => ({
        dialogConfirm: false
    }),

    watch: {
        value(nuevo) {
            this.dialogConfirm = nuevo
        },
        dialogConfirm(nuevo) {
            this.$emit('input', nuevo)
        }
    },

    methods: {
        cerrar() {
            this.dialogConfirm = false
        },
        continueEm(){
            this.$emit("emitConfirm")
        }
    }
}
</script>